module.exports = __webpack_public_path__ + "static/media/gwxl.5308b0c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/gwxl.mp3
// module id = 9yFN
// module chunks = 208